module.exports = __webpack_public_path__ + "static/resume-dd12f754d44f1f3cc8e4fc41a2a58121.pdf";